import {useMutation} from "@tanstack/react-query";
import {setUserTypeGroups} from "../services/UserTypeService";

export function useSetUserTypeGroups() {
    return useMutation({
        mutationFn: setUserTypeGroups,
    });
}
